import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment/moment';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss']
})
export class DescriptionComponent implements OnInit {
  deleteId: number | null = null;
  ToolTip: string = "Delete is not allowed since it is used in Part Details";
  msgtext: string = "";
  descriptionvalue: string = "";
  ListLoadpartDetails: any[] = [];
  loading: boolean = true;
  inputvalidate: boolean = false;
  isValid: boolean = false;
  p: number = 1;
  startingCount: number = 0;
  endingCount: number = 0;
  editobjid: any = "";
  orgId: number = 0;
  userId: number = 0;
  Listdescriptiondetails: any[] = [];
  btnName: string = "Submit";
  @ViewChild('add') add: Popup;
  @ViewChild('update') update: Popup;
  @ViewChild('Askdelete') Askdelete: Popup;
  @ViewChild('delete') delete: Popup;
  @ViewChild('duplicate') duplicate: Popup;
  duplicateMessage: string = 'This Description Already Exists';
  isDescriptionListLoaded: boolean = false;
  isDeleteAvailabilityLoaded: boolean = false;
  alerttxt: any;
  constructor(private dialogService:DialogService,private router:Router,private route : ActivatedRoute,private http:Http,private toastyservice:ToastyService) { 

  }

  ngOnInit() {
    this.loading=true;
    this.isDescriptionListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId=this.route.params['value'].orgId;
      this.userId=this.route.params['value'].userId;
      console.log('OrgId '+ this.orgId);
      console.log('UserId '+ this.userId);
    }
    this.getdescriptiondetails();
    this.CheckToolTip();
  }

	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD DESCRIPTION",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE DESCRIPTION",message:"The Data updated successfully"});
	}

  	
	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE DESCRIPTION",message:"The Data deleted successfully"});
	}
oncount(){
  if(this.p < Math.ceil(this.Listdescriptiondetails.length/10)){
    this.startingCount = (this.p-1)*10;
    if(this.startingCount == 0){
      this.startingCount = 1;
    }
    this.endingCount = this.p*10;
  } else if(this.p == Math.ceil(this.Listdescriptiondetails.length/10)){
    let count = this.Listdescriptiondetails.length%10;
    
    this.startingCount = (this.p-1)*10;
    this.endingCount = this.startingCount + count;
    if(this.startingCount == 0){
      this.startingCount = 1;
      this.endingCount = count;
    }
  }
}

  addOk() {
    this.add.hide();
  }

  updateOk() {
    this.update.hide();
  }

  deleteOk() {
    this.delete.hide();
  }

  getdescriptiondetails(){
    let descriptionObj = {
      'orgId':this.orgId
    }
    return this.http.post("/api/getdescriptiondetails",descriptionObj).subscribe((res: any)=>{
      let responseDescription = res.json();
      if(responseDescription.length>0){
        this.Listdescriptiondetails = responseDescription.map((d: any) => ({...d, status: false, deleteBlockedReason: ''}));
        this.isDescriptionListLoaded = true;
        this.loadDeleteAvailability();
        this.empty();
      }else{
        this.isDescriptionListLoaded = true;
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      }
    },(err: any)=>{
      this.isDescriptionListLoaded = true;
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if(err.status!=200){
        this.alerttxt="Unable to load the description value";
        this.empty();
        this.getWarningFunction(this.alerttxt);
      }
    })
  }

  updateLoadingState() {
    this.loading = !(this.isDescriptionListLoaded && this.isDeleteAvailabilityLoaded);
  }

  loadDeleteAvailability() {
    let descriptionIds: any[] = [];
    for(let i=0;i<this.Listdescriptiondetails.length;i++) {
      this.Listdescriptiondetails[i].status = false;
      this.Listdescriptiondetails[i].deleteBlockedReason = '';
      descriptionIds.push(this.Listdescriptiondetails[i]._id);
    }
    return this.http.post('/api/getDescriptionDeleteAvailability', {
      'ids': descriptionIds,
      'orgId': this.orgId
    }).subscribe(
      (res: any) => {
        let availabilityResponse = res.json().availability || {};
        for(let i=0;i<this.Listdescriptiondetails.length;i++) {
          if(availabilityResponse[String(this.Listdescriptiondetails[i]._id)] && availabilityResponse[String(this.Listdescriptiondetails[i]._id)].canDelete === false) {
            this.Listdescriptiondetails[i].status = true;
            this.Listdescriptiondetails[i].deleteBlockedReason = availabilityResponse[String(this.Listdescriptiondetails[i]._id)].reason || this.ToolTip;
          }
        }
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      },(err: any) => {
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
        if(err.status != 200){
          this.msgtext = "Unable to validate delete availability";
          this.getWarningFunction(this.msgtext);
        }
      }
    )
  }

  getWarningFunction(err: any){
    var toastOptions:ToastOptions={
      title: "description",
      msg: err,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
  };
this.toastyservice.warning(toastOptions);
}
    
  getSuccessFunction(success: any){
    var toastoptions:ToastOptions={
      title:"description",
      msg:success,
      showClose:true,
      timeout:3000,
      theme:'bootstrap',
      onAdd:(toast:ToastData)=>{
},
onRemove: function(toast:ToastData) {
}
    }
    this.toastyservice.success(toastoptions);
  }


validate(){
  if(this.descriptionvalue==''||this.descriptionvalue==undefined||this.descriptionvalue==null){
    this.inputvalidate=true;
    this.isValid=true;
 }else{
 this.inputvalidate=false;
this.isValid=false;
 }

}

empty(){
  this.descriptionvalue="";
  this.inputvalidate=false;
  this.isValid=false;
  this.btnName="Submit";
  this.editobjid="";
}

reset(){
  this.empty();
}

  loadPartdetails() {

    let Obj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getPartdetailsBasedOnOrgId', Obj).subscribe(
    (res: any) => {
    
      
      let resProc: any = res.json();
      console.log("resProc",resProc)
      if(resProc.length>0){
        this.ListLoadpartDetails=resProc;
        this.CheckToolTip();
      }else{
        this.loading=false;
      }
    },(err: any)=>{
      this.loading=false;
      console.log(err);
      
    })
  }

CheckToolTip(){
  if(this.ListLoadpartDetails.length==0||this.ListLoadpartDetails.length==undefined){
  this.loadPartdetails();
  }else if(this.Listdescriptiondetails.length==0||this.Listdescriptiondetails.length==undefined){
  this.getdescriptiondetails();
  }else{
    // this.Listdescriptiondetails.forEach(des=>{
    //   this.ListLoadpartDetails.forEach(loadpartdetails=>{
    //     loadpartdetails.Sparedetails.forEach(sparedetailsDescription=>{
    //     if(sparedetailsDescription.descriptions==des.description)  {
    //           des.status=true;
         
    //     }
    //     })
    //   })

    // })
        for(let des=0;des<this.Listdescriptiondetails.length;des++){
          for(let ld=0;ld<this.ListLoadpartDetails.length;ld++){
                     for(let sd=0;sd<this.ListLoadpartDetails[ld].Sparedetails.length;sd++){
              if(this.ListLoadpartDetails[ld].Sparedetails[sd].descriptions==this.Listdescriptiondetails[des].description&&this.Listdescriptiondetails[des].status==false){
                this.Listdescriptiondetails[des].status=true;
               
              }
            
            }
          }
        }
      this.loading=false;
  }
 
}

Delete(IndexCount: any, ObjectId: any) {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  this.deleteId = ObjectId;
  let desc = this.Listdescriptiondetails.find((d: any) => d._id === ObjectId);
  if (desc && desc.status) {
    // Show popup for delete blocked
    this.showDeleteBlockedPopup(desc.deleteBlockedReason || this.ToolTip);
    return;
  }
  let deleteObj = {
    'data': this.deleteId
  }
  return this.http.post('/api/deleteDescriptionDetails', deleteObj).subscribe(
    (res: any) => {
      let DescriptionResponse = res.json();
      this.showAlertForDeletingdata();
      this.getdescriptiondetails();
    },(err: any)=>{
      this.loading=false;
      this.msgtext = "Unable to delete the Data";
      this.getWarningFunction(this.msgtext);
    })
}

No()
 {
  this.Askdelete.hide();
}

Yes() {

  this.loading=false;
  this.Askdelete.hide();
  let deleteObj = {
      'data':this.deleteId
    }
    return this.http.post('/api/deleteDescriptionDetails', deleteObj).subscribe(
      res => {
     
      // alert('Delete Successfully');
      let DescriptionResponse = res.json();
    //   this.delete.options = {
    //     showButtons: false, // You can hide this in case you want to use custom 
    //     color: "#4180ab",
    //     header: "Make Deleted"
    // };
    //   this.delete.show(this.delete.options);
    this.showAlertForDeletingdata();
      this.getdescriptiondetails();
      this.Askdelete.hide();
    },(err)=>{
      this.loading=false;
      this.msgtext = "Unable to delete the Data";
    this.getWarningFunction(this.msgtext);
    })
}


onsubmit(){
  this.loading=true;
  if(this.descriptionvalue==undefined||this.descriptionvalue==''||this.descriptionvalue==null||/^\s*$/.test(this.descriptionvalue)){
    this.inputvalidate=true;
    this.loading=false;
    return;
  }
  // Duplicate check (case-insensitive, whitespace-normalized)
  let normalizedInput = this.descriptionvalue.trim().toLowerCase();
  if(this.editobjid == null || this.editobjid == undefined || this.editobjid == "") {
    let isDuplicate = this.Listdescriptiondetails.some((d: any) => d.description.trim().toLowerCase() === normalizedInput);
    if(isDuplicate) {
      this.loading = false;
      this.showDuplicatePopup('This Description Already Exists');
      return;
    }
    let reqdescriptionobj={
      'description': normalizedInput,
      'orgId':this.orgId,
      'created_By':this.userId,
      'created_Date': moment.utc().format('YYYY:MM:DD h:mm:ss')
    }
    return this.http.post('/api/addDescription',reqdescriptionobj).subscribe((res: any)=>{
      let descriptionresponse = res.json();
      if(descriptionresponse.message=="This Description Already Exists"){
        this.loading=false;
        this.showDuplicatePopup('This Description Already Exists');
      }else{
        this.getdescriptiondetails();
        this.showAlertForAddingdata();
      }
    },(err: any)=>{
      this.loading=false;
      if(err.status!=200){
        this.alerttxt="Unable to add the description value";
        this.getWarningFunction(this.alerttxt);
      }
    })
  } else {
    let isDuplicateEdit = this.Listdescriptiondetails.some((d: any) => d._id !== this.editobjid && d.description.trim().toLowerCase() === normalizedInput);
    if(isDuplicateEdit) {
      this.loading = false;
      this.showDuplicatePopup('This Description Already Exists');
      return;
    }
    let reqdescriptionobj={
      'description': normalizedInput,
      'orgId':this.orgId,
      'updated_By':this.userId,
      'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
      'objectId':this.editobjid
    }
    return this.http.post("/api/updatedescriptiondetails",reqdescriptionobj).subscribe((res: any)=>{
      let Descriptionresponse = res.json();
      if(Descriptionresponse.message=="This Description Already Exist"){
        this.loading=false;
        this.showDuplicatePopup('This Description Already Exists');
        this.empty();
      }else{
        this.getdescriptiondetails();
        this.showAlertForUpdatingdata();
      }
    },(err: any)=>{
      this.loading=false;
      if(err.status!=200){
        this.alerttxt="Unable to update the Description Value",
        this.getWarningFunction(this.alerttxt);
      }
    })
  }
}
  showDuplicatePopup(message: any) {
    this.duplicateMessage = message;
    this.duplicate.options = {
      showButtons: false,
      color: "#4180ab",
      header: "Description"
    };
    this.duplicate.show(this.duplicate.options);
  }

  showDeleteBlockedPopup(message: any) {
    this.duplicateMessage = message;
    this.duplicate.options = {
      showButtons: false,
      color: "#d9534f",
      header: "Delete Blocked"
    };
    this.duplicate.show(this.duplicate.options);
  }

  duplicateOk() {
    this.duplicate.hide();
  }

  Editing(index: any, objectId: any) {
    this.empty();
    this.editobjid = objectId;
    this.btnName = 'Update';
    for(let getdes of this.Listdescriptiondetails) {
      if(getdes._id == objectId ) {
        this.descriptionvalue = getdes.description.toUpperCase();
      }
    }
    //this.descriptionvalue = this.Listdescriptiondetails[index].description.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./client/app/description/description.component.ts